var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KDialog',{attrs:{"title":_vm.title,"loading":_vm.loading,"visible":_vm.visible,"actions":_vm.dialogActions},on:{"click:remove":_vm.remove,"click:close":_vm.close}},[_c('v-card-text',{staticClass:"headline"},[_vm._v("Deseja realmente apagar o item \""+_vm._s(_vm.data.day)+"\"?")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }